export default "__VITE_ASSET__DnZfc33Z__"